// The West Coast scene behind the sign-in and clock-in screens: a soft sky and sun, the ocean, and
// palm trees in the store's blues at the corners. Drawn here (no pictures to load), kept quiet so
// the logo and the badges stay the point; it never catches a tap (pointer-events: none in CSS).

/**
 * One palm: a curved trunk with fronds fanned from its top. Drawn in a 260 × 300 box whose trunk
 * stands on the ground (y 320); `x` is the box's left edge, `flip` turns it to face the other way.
 */
function Palm({ x, scale = 1, flip = false, color }: { x: number; scale?: number; flip?: boolean; color: string }) {
  // Nine fronds fanned over the top of the trunk, the back ones first so the front ones sit over them.
  const fronds = [-168, -146, -124, -100, -78, -56, -34, -12, 14];
  const tx = flip ? x + 260 * scale : x;
  const ty = 320 - 300 * scale;
  return (
    <g transform={`translate(${tx} ${ty}) scale(${flip ? -scale : scale} ${scale})`} fill={color}>
      {/* The trunk leans toward the water; its rings are a lighter stroke. */}
      <path d="M112 300 C 120 236, 134 176, 150 120 L 166 122 C 152 178, 140 238, 136 300 Z" />
      <path d="M121 276 q13 -4 26 0 M123 250 q13 -4 25 0 M127 224 q12 -4 24 0 M132 198 q12 -4 23 0 M138 172 q11 -4 22 0" fill="none" stroke="#fff" strokeOpacity="0.35" strokeWidth="3" strokeLinecap="round" />
      {/* The fronds: long leaves that droop at the tip, with the leaflets notched along the edge. */}
      {fronds.map((a, i) => (
        <g key={a} transform={`translate(156 118) rotate(${a})`} opacity={i % 2 ? 1 : 0.92}>
          <path d="M0 0 C 30 -22, 80 -26, 124 -8 C 92 2, 56 14, 24 40 C 18 24, 8 10, 0 0 Z" />
          <path d="M10 5 l6 14 M26 2 l7 15 M44 0 l7 15 M62 -1 l7 14 M80 -1 l6 13 M98 -2 l5 11" stroke="#fff" strokeOpacity="0.26" strokeWidth="2.4" strokeLinecap="round" fill="none" />
        </g>
      ))}
      <circle cx="152" cy="124" r="9" />
      <circle cx="165" cy="130" r="7" />
      <circle cx="143" cy="132" r="7" />
    </g>
  );
}

export function GateScene() {
  return (
    <div className="gate-scene" aria-hidden="true">
      <div className="gate-sun" />
      {/* The ocean along the bottom, stretched to the screen, with the sun's light on it and a few lazy waves. */}
      <svg className="gate-sea" viewBox="0 0 1600 300" preserveAspectRatio="none" focusable="false">
        <defs>
          <linearGradient id="gs-sea" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#CFE1FF" />
            <stop offset="1" stopColor="#8DB8FF" />
          </linearGradient>
        </defs>
        <path d="M0 40 Q 200 20 400 40 T 800 40 T 1200 40 T 1600 40 L1600 300 L0 300 Z" fill="url(#gs-sea)" />
        <path d="M640 90 Q 800 72 960 90" stroke="#fff" strokeOpacity="0.55" strokeWidth="4" fill="none" strokeLinecap="round" vectorEffect="non-scaling-stroke" />
        <path d="M520 150 Q 800 124 1080 150" stroke="#fff" strokeOpacity="0.35" strokeWidth="4" fill="none" strokeLinecap="round" vectorEffect="non-scaling-stroke" />
        <path d="M140 210 Q 300 190 460 210 M1140 210 Q 1300 190 1460 210" stroke="#fff" strokeOpacity="0.3" strokeWidth="4" fill="none" strokeLinecap="round" vectorEffect="non-scaling-stroke" />
      </svg>
      {/* Gulls, far off. */}
      <svg className="gate-gulls" viewBox="0 0 300 80" focusable="false">
        <path d="M20 40 q12 -10 22 0 q10 -10 22 0 M90 18 q9 -8 17 0 q8 -8 17 0 M200 50 q10 -9 19 0 q9 -9 19 0" stroke="#0057FF" strokeOpacity="0.4" strokeWidth="3" fill="none" strokeLinecap="round" />
      </svg>
      {/* The palms at each corner: the store's navy up front, its blue behind. */}
      <svg className="gate-palms gate-palms-l" viewBox="0 0 520 320" focusable="false">
        <Palm x={0} scale={1.0} color="#0057FF" />
        <Palm x={120} scale={1.06} flip color="#07152D" />
      </svg>
      <svg className="gate-palms gate-palms-r" viewBox="0 0 520 320" focusable="false">
        <Palm x={260} scale={1.0} flip color="#0057FF" />
        <Palm x={120} scale={1.06} color="#07152D" />
      </svg>
    </div>
  );
}
